<template>
  <div class="mt-8 flex justify-center content-center">
    <i class="fas fa-spinner fa-spin"></i>
  </div>
</template>

<script>
import util from '@/util'
import config from '@/config'

export default {
  data() {
    return {

    }
  },
  async mounted() {
    const code = util.getParamValue('code')
    if (code) {
      const googleRedirect = `${config.presenterDomain}/google-auth?provider=google`

      const resp = await this.$http.post(config.api.googleSigninPPT, {
        code,
        redirectUri: googleRedirect,
      })
      window.opener.handleTokenApp(resp.body.token)
      window.close()
    }
  },
}
</script>

<style scoped>
</style>
